module.exports = __webpack_public_path__ + "static/media/unknown_release.8669daed.svg";